import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <LandingPage data-id="element-0" />;
}